// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import BidsTable from './bids-table';
// assets
//

// ----------------------------------------------------------------------

export default function TechnicalBids() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <BidsTable />
        </Container >
    );
}
